import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, ShieldAlert, Phone } from 'lucide-react';
import { NAV, SITE } from '@/data/content';

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200">
      {/* Top strip */}
      <div className="bg-[#0b2545] text-slate-100 text-xs">
        <div className="max-w-7xl mx-auto px-4 h-9 flex items-center justify-between">
          <span className="tracking-wide">Kress &amp; Associates — Educating Schools Since 1996</span>
          <a href={`tel:${SITE.phone.replace(/[^0-9]/g,'')}`} className="flex items-center gap-2 hover:text-amber-300 transition-colors">
            <Phone className="h-3.5 w-3.5" />
            <span>{SITE.phone}</span>
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="h-11 w-11 rounded-md bg-gradient-to-b from-[#0b2545] to-[#123a6b] flex items-center justify-center shadow-md">
            <ShieldAlert className="h-6 w-6 text-amber-400" />
          </div>
          <div className="leading-tight">
            <div className="font-serif text-xl font-bold text-[#0b2545] tracking-tight">DrugAwareness<span className="text-amber-500">USA</span>.net</div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Drug &amp; Alcohol Awareness</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  isActive
                    ? 'text-amber-600 bg-amber-50'
                    : 'text-slate-700 hover:text-[#0b2545] hover:bg-slate-100'
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="lg:hidden p-2 rounded-md hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-medium ${
                    isActive ? 'text-amber-600 bg-amber-50' : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
